"use strict";

const moment = require("moment");

// Formats
const FHIR_DATE = "YYYY-MM-DD";
const STANDARD_DATE = "MM/DD/YYYY";
const MEDIUM_DATE = "MMM-DD-YYYY";
const STANDARD_DATETIME = "MM/DD/YYYY hh:mm a";

// Validators
const isValidDate = (date) => /^\d{2}\/\d{2}\/\d{4}$/g.test(date);
const isValidFHIRDate = (date) => /^\d{4}-\d{2}-\d{2}$/g.test(date);

const isValidDateTime = (date) =>
  /^([0]\d|[1][0-2])\/([0-2]\d|[3][0-1])\/([2][01]|[1][6-9])\d{2}(\s([0]\d|[1][0-2])(:[0-5]\d){1,2})*\s*([aApP][mM]{0,2})?$/g.test(
    date
  );
const isValidFHIRDateTime = (date) =>
  /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}(:[0-9]{2})?(\.[0-9]{3})?Z$/g.test(
    date
  );
// const hasValidTimeComponent = date => (/[0-9]{2}:[0-9]{2}(:[0-9]{2})?(\.[0-9]{3})?/g).test(date);

// Formatters
/**
 * Given a date value with a given format, reformat the date to a FHIR format
 * @param date
 * @param fromFormat
 */
const fhirDate = (date, fromFormat) =>
  moment(date, fromFormat).format(FHIR_DATE);
/**
 * Given a date and format, return a standard date format
 * @param date
 * @param fromFormat
 */
const standardDate = (date, fromFormat) =>
  moment(date, fromFormat).format(STANDARD_DATE);

const getDate = (date, fromFormat) => {
  let newDate = date;
  if (fromFormat) {
    newDate = moment(date, fromFormat);
  }
  if (!moment.isMoment(newDate) && !moment.isDate(newDate)) {
    throw new Error(
      "fhirDateTime requires a valid date or moment or a string and a valid moment date format"
    );
  }
  return newDate;
};
/**
 * Given a datetime (any format), return a FHIR UTC-formatted date YYYY-MM-DDT00:00:00.000Z
 * @param date
 */
const fhirDateTime = (date, fromFormat = STANDARD_DATETIME) =>
  moment(getDate(date, fromFormat)).utc().toDate().toISOString();

/**
 * Given a UTC datetime and format, return a local time display
 * @param date
 */
const standardDateTime = (date, fromFormat) =>
  moment(moment.utc(getDate(date, fromFormat)).toDate()).format(
    STANDARD_DATETIME
  );

const mediumDate = (date, fromFormat) =>
  moment(moment.utc(getDate(date, fromFormat)).toDate()).format(MEDIUM_DATE);

/**
 * Given a due date, return a string the represents how that date/time relates to the current time
 * i.e. Today, Yesterday, Tomorrow, or the standard date format
 */
const dueDateString = (dueDate) => {
  if (!dueDate) {
    return;
  }
  const due = moment(dueDate);
  if (!due.isValid()) {
    return;
  }
  if (due.isSame(moment(), "day")) {
    return "Today";
  }
  const yesterday = moment().subtract(1, "days");
  if (due.isSame(yesterday, "day")) {
    return "Yesterday";
  }
  const tomorrow = moment().add(1, "days");
  if (due.isSame(tomorrow, "day")) {
    return "Tomorrow";
  }
  return standardDate(dueDate);
};

const form2fhir = (dob) => {
  const a = fhirDate(dob, STANDARD_DATE);
  return a;
};
const fhir2form = (fhir) => standardDate(fhir, FHIR_DATE);

module.exports = {
  mediumDate,
  form2fhir,
  fhir2form,
  fhirDate,
  fhirDateTime,
  standardDate,
  standardDateTime,
  isValidDate,
  isValidDateTime,
  isValidFHIRDate,
  isValidFHIRDateTime,
  dueDateString,
  FHIR_DATE,
  STANDARD_DATE,
  STANDARD_DATETIME
};
